import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import SocialProofSection from '../components/SocialProofSection';
import ServicesSection from '../components/ServicesSection';
import ROISection from '../components/ROISection';
import PortfolioSection from '../components/PortfolioSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const WHATSAPP_URL = "https://wa.me/905326346462?text=Hello%20Sentetica,%20I%20would%20like%20to%20get%20information%20and%20request%20a%20price%20quote";

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-[100] bg-white flex items-center justify-center"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="text-center"
            >
              <span className="font-heading text-3xl font-black text-[#0A0A0A]">
                Sente<span className="text-[#E60000]">tica</span>
              </span>
              <motion.div
                className="mt-3 h-1 bg-[#E60000] rounded-full mx-auto"
                initial={{ width: 0 }}
                animate={{ width: 100 }}
                transition={{ duration: 0.6 }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Header whatsappUrl={WHATSAPP_URL} />
      
      <main>
        <HeroSection whatsappUrl={WHATSAPP_URL} />
        <SocialProofSection />
        <ServicesSection whatsappUrl={WHATSAPP_URL} />
        <PortfolioSection />
        <ROISection />
        <WhyChooseUsSection whatsappUrl={WHATSAPP_URL} />
        <ContactSection whatsappUrl={WHATSAPP_URL} />
      </main>

      <Footer whatsappUrl={WHATSAPP_URL} />
    </div>
  );
};

export default LandingPage;
